<div class="margin-top-2">
  @if (notificationsForm) {
    <form id="notificationsForm" role="form" [formGroup]="notificationsForm">
      <fieldset class="usa-fieldset">
        <div formArrayName="notifications">
          @for (control of notificationsForm.controls['notifications']['controls']; track control; let i = $index) {
            <div class="usa-checkbox"
              [formGroup]="control">
              <input
                class="usa-checkbox__input"
                id="{{ control.controls.id.value }}"
                type="checkbox"
                formControlName="checkbox"/>
              <label class="usa-checkbox__label"
              for="{{ control.controls.id.value }}">{{ control.controls.text.value }}</label>
            </div>
          }
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 margin-top-2">
          <button type="button" class="usa-button" (click)="savePref()">Save</button>
        </div>
      </fieldset>
    </form>
  }
</div>
